import React from 'react';
import { Base } from './Base';
import { Text, TextLink } from './Text';
import { Link } from 'react-router-dom';
import { ChartIcon } from './icons';
import { mpEvent, MPEvents } from 'src/utils/mixpanel';
import { formatDate } from 'src/utils/misc';

interface EFAssessmentReviewDueProps {
  showDate?: string;
  assessment: {
    id: string;
    name: string;
  };
  truncate?: boolean;
}

export const EFAssessmentReviewDue: React.FC<EFAssessmentReviewDueProps> = ({ showDate, assessment, truncate }) => {
  return (
    <Base
      iconComponent={<ChartIcon />}
      constentComponent={
        <Text nowrap={truncate}>
          {showDate && <Text className="sdate">{formatDate(showDate)}</Text>}
          Assessment{' '}
          <Link
            to={`/risk-assessments/${assessment.id}`}
            onClick={() =>
              mpEvent(MPEvents.Link, {
                source: {
                  value: ['Timeline'],
                },
                destination: {
                  value: ['Assessment'],
                  params: {
                    id: assessment.id,
                  },
                },
                tags: ['TIMELINE', 'ASSESSMENT'],
              })
            }
          >
            <TextLink>{assessment.name}</TextLink>
          </Link>{' '}
          due for review.
        </Text>
      }
    />
  );
};
